export default __webpack_public_path__ + "static/media/TemplatePorcentajesBudgetForecast.806b5974.xlsx";